import { z } from "zod";

import { createTableauSettingsEditorStore } from "@vm/tableau";

export const ComparisonSettingsSchema = z.object({
  colors: z
    .object({
      headerBackground: z.string().default("#0f3044"),
      accordionHeaderBackground: z.string().default("#e5e7eb"),
      subjectRowBackground: z.string().default("#f9fafb"),
      referenceRowBackground: z.string().default("#f0fdf4"),
      typeColors: z
        .record(z.string(), z.string())
        .default({ Objecten: "#FFA500", Referenties: "#1a4731" }),
    })
    .default({
      headerBackground: "#0f3044",
      accordionHeaderBackground: "#e5e7eb",
      subjectRowBackground: "#f9fafb",
      referenceRowBackground: "#f0fdf4",
      typeColors: { Objecten: "#FFA500", Referenties: "#1a4731" },
    }),
  layout: z
    .object({
      minColumnWidth: z.number().default(200),
      fontSize: z.number().default(14),
      capitalizeValues: z.boolean().default(true),
    })
    .default({ minColumnWidth: 200, fontSize: 14, capitalizeValues: true }),
});

export type ComparisonSettings = z.infer<typeof ComparisonSettingsSchema>;

export const useSettingsEditorStore = createTableauSettingsEditorStore(
  ComparisonSettingsSchema,
);
